import React from 'react';
import { Link } from 'react-router-dom';
import { Book } from '../../types';

interface BookCardProps {
  book: Book;
}

export const BookCard: React.FC<BookCardProps> = ({ book }) => {
  return (
    <Link
      to={`/books/${book._id}`}
      className="block bg-white rounded-lg shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden group border border-primary-100"
    >
      <div className="aspect-[3/4] bg-primary-100 overflow-hidden relative">
        {book.coverImage ? (
          <img
            src={book.coverImage}
            alt={book.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center">
            <span className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">{book.title.charAt(0)}</span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>
      <div className="p-2 sm:p-3 lg:p-4">
        <h3 className="font-semibold text-slate-900 truncate text-sm sm:text-base group-hover:text-primary-700 transition-colors">{book.title}</h3>
        <p className="text-xs sm:text-sm text-slate-500 truncate">by {book.author}</p>
        {book.category && (
          <span className="inline-block mt-1.5 sm:mt-2 px-2 sm:px-2.5 py-0.5 sm:py-1 text-[10px] sm:text-xs font-medium bg-primary-100 text-primary-700 rounded-full">
            {book.category}
          </span>
        )}
      </div>
    </Link>
  );
};
